module.exports = __webpack_public_path__ + "img/jnmh_01.289d4355.jpg";